<template>
  <el-card
    v-bind="$attrs"
    class="ui-section-card"
    :class="{ 'is-headerless': !hasHeader }"
    :shadow="shadow"
    :body-style="bodyStyle"
    v-on="$listeners"
  >
    <div v-if="hasHeader" slot="header" class="ui-section-card__header">
      <div
        v-if="hasTitle"
        class="ui-section-title"
        :class="{ 'has-icon': Boolean(icon) }"
      >
        <i v-if="icon" :class="icon" aria-hidden="true"></i>
        <slot name="title">{{ $t(title) }}</slot>
      </div>
      <div v-if="hasActions" class="ui-section-card__actions">
        <slot name="actions" />
      </div>
    </div>
    <slot />
  </el-card>
</template>

<script>
export default {
  name: 'UiSectionCard',
  inheritAttrs: false,
  props: {
    title: { type: String, default: '' },
    icon: { type: [String, Array, Object], default: '' },
    shadow: { type: String, default: 'never' },
    bodyStyle: { type: Object, default: () => ({}) }
  },
  computed: {
    hasTitle () {
      return Boolean(this.title || this.icon || this.$slots.title || this.$scopedSlots.title)
    },
    hasActions () {
      return Boolean(this.$slots.actions || this.$scopedSlots.actions)
    },
    hasHeader () {
      return Boolean(this.hasTitle || this.hasActions)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-section-card__header {
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--ui-space-lg);
}

/* 无标题卡片仍是完整的内容容器，不依赖各页面重复补边框。 */
.ui-section-card.is-headerless {
  overflow: hidden;
  border-radius: var(--ui-radius-large);
}

.ui-section-card__actions {
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  gap: var(--ui-control-gap);
}

.ui-section-card__actions ::v-deep .el-button + .el-button {
  margin-left: 0;
}
</style>
